import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import {
    floorGameColor as color,
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledInteraction,
    styledMedia,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './CopyTextAction.tokens';

export const StyledCopyTextAction = styled.button.attrs({ type: 'button' })`
    ${styledReset.button};
    display: flex;
    gap: ${tokens.gap}px;
    border-radius: 2px;
    outline: 2px solid transparent !important;
    outline-offset: 2px;
    opacity: 1;
    transition-property: opacity, outline-color;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &:disabled {
        ${styledInteraction.interactionDisable};
    }

    &:focus-visible {
        outline-color: ${designColor.brandPurple} !important;
    }

    &:active {
        opacity: 0.8;
    }
`;

export const Text = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    display: block;
    font-size: ${tokens.fontSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
    white-space: nowrap;
    text-decoration: underline 1px transparent;
    transition: text-decoration-color ${duration.normal}ms ${easing.cubic};

    ${StyledCopyTextAction}:hover & {
        text-decoration-color: rgb(255, 255, 255, 1);
    }
`;

const iconBase = css`
    ${styledMedia.iconWrapper};
    width: ${tokens.iconSize}px;
    height: ${tokens.iconSize}px;
`;

export const CheckIconWrapper = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    ${iconBase};
    color: ${color.green};
`;

export const CopyIconWrapper = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    ${iconBase};
    color: rgb(255, 255, 255, 0.5);
    transition: color ${duration.normal}ms ${easing.cubic};

    ${StyledCopyTextAction}:hover & {
        color: rgb(255, 255, 255, 0.8);
    }
`;
